import React, { Component } from "react";
import PropTypes from 'prop-types';

function getNodeIndex(node) {
  var index = 0;
  while ((node = node.previousSibling)) {
    if (node.nodeType != 3 || !/^\s*$/.test(node.data)) {
      index++;
    }
  }
  return index;
}

class Panel extends Component {
  componentDidMount() {
    setTimeout(this.updateHeight, 0);
  }

  componentDidUpdate() {
    setTimeout(this.updateHeight, 0);
  }

  setHeight = element => {
    if (element != null && element.clientHeight != 0) {
      if (element.clientHeight != this.lastHeight) {
        this.lastHeight = element.clientHeight;
        this.context.modifySize(element.clientHeight, getNodeIndex(element.parentElement.parentElement));
      }
    }
  };

  updateHeight = () => {
    this.setHeight(this.panel);
  };

  render() {
    return (<div className="accordion__content" ref={r => this.panel = r}>
      {this.props.children}
    </div>);
  }
}

Panel.contextTypes = {
  modifySize: PropTypes.func
};

Panel.propTypes = {
  actions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  title: PropTypes.string.isRequired
};

class CustomAccordion extends Component {

  state = {
    height: new Array(React.Children.toArray(this.props.children).length),
    index: this.props.index || 0
  }

  getChildContext() {
    return {
      modifySize: this.setHeight
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (this.state.index != next.index) {
      this.setState({ index: next.index });
    }
  }

  seleziona = indice => {
    this.setState({ index: indice });
    if (this.props.onSelect) {
      this.props.onSelect(indice);
    }
  }

  setHeight = (height, index) => {
    if (this.state.height[index] != height && height != 0) {
      this.state.height[index] = height;
      this.setState({ height: this.state.height });
    }
  }

  render() {
    return (<div className="accordion">
      {this.props.children.map((x, i) => (
        <div className="accordion__panel" key={i}>
          <div className="accordion__header" onClick={() => this.seleziona(i)}>
            {x.props.title}
            {x.props.actions && <div className="accordion__actions" onClick={(e) => e.stopPropagation()}>{x.props.actions}</div>}
          </div>
          <div className="accordion__subpanel" style={{ height: x.props.keepItOpen || (i === this.state.index ? this.state.height[i] : (this.state.height[i] == undefined ? undefined : 0)) }}>
            {React.Children.toArray(this.props.children)[i]}
          </div>
        </div>
      )
      )}
    </div>);
  }
}

CustomAccordion.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onSelect: PropTypes.func,
  index: PropTypes.number
};

CustomAccordion.childContextTypes = {
  modifySize: PropTypes.func
};

CustomAccordion.Panel = Panel;
export default CustomAccordion;